import { MANUALS_API_PREFIX } from '../utils/constants';

const SKIP_URL_RE = /^(blob:|data:|javascript:|mailto:|#)/i;
const MANUALS_PATH_SEGMENT = '/manuals/';

export function manualsApiUrl(path) {
  const base = String(process.env.VUE_APP_API_URL || '').replace(/\/$/, '');
  const raw = String(path || '');
  if (!raw) return base;
  if (/^https?:\/\//i.test(raw)) return raw;
  const normalized = raw.startsWith('/') ? raw : `/${raw}`;
  return `${base}${normalized}`;
}
const CSS_URL_RE = /url\(\s*(['"]?)([^'")]+)\1\s*\)/gi;
const CSS_IMPORT_RE = /@import\s+(?:url\(\s*)?(['"]?)([^'")]+)\1\s*\)?/gi;
const CSS_PATH_RE = /\.css(?:$|\?)/i;

export function isSkippableUrl(value) {
  const href = String(value || '').trim();
  return !href || SKIP_URL_RE.test(href);
}

export function pageDirectoryUrl(pageUrl = '') {
  return String(pageUrl || '').replace(/[^/]*$/, '');
}

export function manualsPathFromHref(href, baseUrl) {
  if (isSkippableUrl(href)) return '';
  try {
    const parsed = new URL(href, baseUrl);
    const idx = parsed.pathname.indexOf(MANUALS_PATH_SEGMENT);
    if (idx === -1) return '';
    const tail = parsed.pathname.slice(idx + MANUALS_PATH_SEGMENT.length);
    return `${MANUALS_API_PREFIX}/${tail}${parsed.search}`;
  } catch (_) {
    return '';
  }
}

export function shouldTreatAsCss({ href = '', rel = '', asType = '' } = {}) {
  const relNorm = String(rel || '').toLowerCase();
  const asNorm = String(asType || '').toLowerCase();
  if (relNorm.includes('stylesheet')) return true;
  if (asNorm === 'style') return true;
  return CSS_PATH_RE.test(String(href || ''));
}

export function collectCssUrls(cssText) {
  const urls = new Set();
  const source = String(cssText || '');
  CSS_URL_RE.lastIndex = 0;
  CSS_IMPORT_RE.lastIndex = 0;
  let match = CSS_URL_RE.exec(source);
  while (match) {
    const value = String(match[2] || '').trim();
    if (value) urls.add(value);
    match = CSS_URL_RE.exec(source);
  }
  match = CSS_IMPORT_RE.exec(source);
  while (match) {
    const value = String(match[2] || '').trim();
    if (value) urls.add(value);
    match = CSS_IMPORT_RE.exec(source);
  }
  return [...urls].sort((a, b) => b.length - a.length);
}

export function replaceCssResource(cssText, from, to) {
  if (!from || from === to) return String(cssText || '');
  return String(cssText || '').split(from).join(to);
}

export function parseSrcset(value) {
  return String(value || '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const bits = part.split(/\s+/);
      return { url: bits[0], descriptor: bits.slice(1).join(' ') };
    });
}

export function serializeSrcset(entries = []) {
  return entries
    .map((entry) => [entry.url, entry.descriptor].filter(Boolean).join(' '))
    .join(', ');
}

export function resolveDocumentBaseUrl(doc, pageUrl) {
  const publishedBase = doc && doc.querySelector && doc.querySelector('base[href]');
  const href = publishedBase && publishedBase.getAttribute('href');
  if (!href) return pageDirectoryUrl(pageUrl);
  try {
    return pageDirectoryUrl(new URL(href, pageUrl).href);
  } catch (_) {
    return pageDirectoryUrl(pageUrl);
  }
}
